import React, { useState } from "react";
import { LogIn, Menu, ShoppingBag } from "lucide-react";
// import useActiveLink from "pages/Components/Navigation/Navbars/useActiveLink";
import { Link, NavLink } from "react-router-dom";

// Image
import logoDark from "../../assets/images/logo/logo2.png";
import logoLight from "../../assets/images/logo/logo2.png";

const Navbar = () => {
  const [isToggle, setIsToggle] = React.useState<boolean>(false);
  const [navClass, setNavClass] = React.useState<string>("");

  const [activeLink, handleLinkClick] = useState(".navbar-menu li.active");

  // scroll
  const scrollNavigation = () => {
    var scrollUp = document.documentElement.scrollTop;
    if (scrollUp >= 50) {
      setNavClass("is-sticky");
    } else {
      setNavClass("");
    }
  };

  React.useEffect(() => {
    window.addEventListener("scroll", scrollNavigation, true);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("scroll", scrollNavigation, true);
    };
  }, []);

  return (
    <React.Fragment>
      <nav
        className={`fixed inset-x-0 top-0 z-50 flex items-center justify-center h-20 py-3 bg-[#32245b] dark:[&.is-sticky]:bg-black dark:border-zinc-800 [&.is-sticky]:shadow-lg [&.is-sticky]:shadow-slate-200/25 dark:[&.is-sticky]:shadow-zinc-700/30 navbar ${navClass}`}
        id="navbar"
        style={{ direction: "rtl" }}
      >
        <div className="container 2xl:max-w-[87.5rem] px-4 mx-auto flex items-center self-center w-full">
          <div className="flex justify-center gap-2">
            <div className="ltr:ml-auto rtl:mr-auto md:hidden navbar-toggale-button">
              <button
                type="button"
                className="flex items-center justify-center size-[37.5px] p-0 text-gray-300 btn bg-custom-500 border-custom-500 hover:text-gray-300 hover:bg-custom-600 hover:border-custom-600 focus:text-gray-300 focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-gray-300 active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={() => setIsToggle(!isToggle)}
              >
                <Menu></Menu>
              </button>
            </div>
            <div className="shrink-0">
            <Link to="/">
              <img
                src={logoDark}
                alt="لوگو"
                className="block h-8 dark:hidden"
              />
              <img
                src={logoLight}
                alt="لوگو"
                className="hidden h-8 dark:block"
              />
            </Link>
          </div>
         
          </div>
          <div className="mx-auto">
            <ul
              id="navbar7"
              className={`absolute inset-x-0 z-20 items-center py-3 mt-px bg-purple-950 shadow-lg md:mt-0 dark:bg-zinc-800 dark:md:bg-transparent md:z-0 navbar-menu rounded-b-md md:shadow-none md:flex top-full ltr:ml-auto rtl:mr-auto md:relative md:bg-transparent md:rounded-none md:top-auto md:py-0 ${
                !isToggle ? "hidden" : ""
              }`}
            >
                 <li>
                <a
                  href="#"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/")}
                >
                  صفحه اصلی
                </a>
              </li>
              <li>
                <a
                
                  href="#home"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/Home" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/Home")}
                >
                  ثبت نام
                </a>
              </li>
              <li>
                <a
                  href="#product"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/Features" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/Features")}
                >
                  درباره محصول
                </a>
              </li>
              {/* <li>
                <a
                  href="#features"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/Features" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/Features")}
                >
                  مشتریان ما
                </a>
              </li> */}
              <li>
                <a
                  href="#about"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/About" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/About")}
                >
                  درباره ما
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/contact" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/contact")}
                >
                  ارتباط با ما
                </a>
              </li>
              <li>
                <a
                  href="#membeteam"
                  className={`block md:inline-block px-4 md:px-3 py-2.5 md:py-0.5 text-15 font-medium transition-all duration-300 ease-linear hover:text-custom-500 [&.active]:text-custom-500 text-gray-300 dark:hover:text-custom-500 dark:[&.active]:text-custom-500 ${
                    activeLink === "/membeteam" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("/membeteam")}
                >
                  تیم ما
                </a>
              </li>
             
            </ul>
          </div>
          <NavLink
          // onClick={()=> alert("با ارزش پوزش این صفحه در حال توسع میباشد")}
              to="/login"
              className=" border-0 btn bg-gradient-to-r  text-white from-purple-500 to-custom-500"
            >
              <span className="align-middle">ورود به سامانه</span>{" "}
              <LogIn className="inline-block size-4 ltr:ml-1 rtl:mr-1"></LogIn>
            </NavLink>
        </div>
      </nav>
    </React.Fragment>
  );
};

export default Navbar;
